import { h, Component } from 'preact';
import Current from '../current';
import style from './style';
import delve from 'dlv';
import cx from 'classnames';
import { trackingProvider, DIMENSION } from '@cube/track';

@trackingProvider({
	[DIMENSION.componentpath]: 'WeatherMiniView'
})
export default class WeatherMiniView extends Component {

	render({ conditions, currentUnit, config, location, changeUnit, weatherLink, alerts, showAlerts, displayMode, theme }) {

		return (<div key="container1" class={cx(style.containerMini, style[theme])}>
			<a href={weatherLink} target="_blank" rel="noopener noreferrer">
				<Current
					today={conditions}
					unit={currentUnit}
					changeUnit={changeUnit}
					displayMode={displayMode}
					theme={theme}
				/>

				<div class={style.weatherLocWrap}>
					<div class={style.miniLocation}>
						{location.name}
					</div>
					{showAlerts && delve(alerts, 'totalAlerts') &&
						<div class={style.alertDot} />
					}
				</div>
			</a>
		</div>
		);
	}
}
